import { SymbolData } from '../types';
import { PAN_STEM_COMBO_LOOKUP } from './pan-xiangyi.generated';

const baseStemCombinationsData: SymbolData[] = [
  {
    id: 'combo-yi',
    char: '乙',
    pinyin: 'Yǐ 组合',
    summary: '乙木组合：日奇之操',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '基础：奇门的结构',
        logic: '理解天盘与地盘的关系是解读组合象意的前提。',
        subItems: [
          { label: '内外关系', content: '天盘代表表象、外在，地盘代表内在、内心。（例：天盘戊地盘丁壬，外表忠厚，内里男盗女娼；天盘丙外表热情，地盘戊想你的钱）。' },
          { label: '上下关系', content: '天盘代表上部分，地盘代表下部分。' },
          { label: '资金关系', content: '天盘代表投资的钱，地盘戊代表收回的钱。' },
          { label: '综合判断', content: '天地盘组合起来看象意，也要参考星门神。' },
        ],
      },
      {
        title: '乙+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '花卉、艺术品、绳子等。' },
          { label: '外景', content: '草地或绿植。' },
          { label: '联想', content: '乙+乙，看成牵手、握手（乙为手）；亲吻（乙为嘴）；头发厚长（乙为发）；两个老婆（乙为妻）；戴着项链、打领带（乙为脖子、乙为弯曲缠绕）。' },
          { label: '格局', content: '日奇伏吟：两乙相遇，伏吟主迟滞。乙木为花草，重叠则乱，主事情纠缠不清，拖拉，不宜进取，宜静守。' },
          { label: '其他', content: '测人，走路不直，是罗圈腿等。' },
        ],
      },
      {
        title: '乙+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '炉灶等发热工具、窗子等。' },
          { label: '外景', content: '开红花的植物、化工厂、热能厂等。' },
          { label: '联想', content: '床上铺的是红被单（乙为床，丙主红色）；头发乱了，头发染红了；拐弯的路上有红灯（乙主弯曲）；女警察（丙主权柄，为警察）。' },
          { label: '格局', content: '奇仪顺遂：木生火，乙木生丙火，吉利之象。贵人升迁，职务进益，百事可为，大吉大利。' },
        ],
      },
      {
        title: '乙+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '电器、电子产品、电灯等。' },
          { label: '外景', content: '玫瑰、月季、小枣树、刺槐等带刺的植物。' },
          { label: '联想', content: '抽烟的女人、老婆抽烟、桌子上有烟；发信息、打电话；台灯；修家电；红领巾；文字键盘；女人流产、来例假了。' },
          { label: '格局', content: '奇仪相佐：同为阴性，木火相生。文书事吉，百事可为，利于考试、学习、文章之事。' },
        ],
      },
      {
        title: '乙+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '墙面上有艺术品。' },
          { label: '外景', content: '有绿色植物的庭院，或一道弯曲的墙，墙上有爬山虎等藤类植物。' },
          { label: '联想', content: '挖土；挖掘机；子宫增生；女人是管钱的、女会计；戴手套；该出钱了（用手拿钱）；土炕、火炕；屋顶上有草。' },
          { label: '格局', content: '阴阳互利：乙木克戊土，但阴阳相吸。利于投资、合作，门吉更吉，门凶事有阻。' },
        ],
      },
      {
        title: '乙+己',
        logic: '',
        subItems: [
          { label: '内景', content: '有盆景花卉或艺术品等，也代表凌乱，有电线绳索物。' },
          { label: '外景', content: '杂乱的草或凌乱的垃圾等。' },
          { label: '联想', content: '捡垃圾、做雕塑的、搞策划的、小树要死了、给庄稼施肥。' },
          { label: '格局', content: '日奇入墓：乙木克己土，己为阴土陷阱。被土埋没，作事暗昧，不吉。此时宜退不宜进。' },
        ],
      },
      {
        title: '乙+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '金属横梁，或金属门窗。' },
          { label: '外景', content: '弯曲的大路或林荫大道，堆放大型金属器具。' },
          { label: '联想', content: '夫妻在一起；女人走在路上；床上有床垫；女人在车上、女人开车；弯路上有个收费站。' },
          { label: '格局', content: '日奇被刑：乙庚合，但庚金克乙木。夫妻反目，出行有阻，钱财耗散，防争讼是非。' },
        ],
      },
      {
        title: '乙+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗已经变形，或窗前放有花草，或一张金属床等。' },
          { label: '外景', content: '弯曲的小路，或草地上有一条小路。' },
          { label: '联想', content: '金属床、手破了、肠炎、拉肚子、做手术、剪发了；妻子犯错误、医生出错了、庄稼病了、有果实的树、受伤了。' },
          { label: '格局', content: '青龙逃走：辛金冲克乙木，乙木受损。人亡财破，奴仆拐带，六畜损伤，大凶。' },
        ],
      },
      {
        title: '乙+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '水管线、水龙头、鱼缸、浴缸等。床铺下面潮湿或有下水管道。' },
          { label: '外景', content: '弯曲的河流或不规则的湖泊，也代表河边青草。' },
          { label: '联想', content: '游泳、洗澡、女澡堂。临玄武，跟人私奔了。钓鱼、一条弯曲的河流；水稻田。' },
          { label: '格局', content: '日奇入地：水生木，乙木随水漂流。尊卑悖乱，官讼是非，有人谋害，凡事不吉。' },
        ],
      },
      {
        title: '乙+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '喜水植物盆景、菜盘子、菜汤、酒类、饮料、厕所等。床铺下面潮湿或有下水管道。' },
          { label: '外景', content: '荷塘、芦苇塘、湿地、菜地等。' },
          { label: '联想', content: '撒网捕鱼、下水道、酒鬼、脚扭伤了、青稞酒、菜汤、踩到瓜皮了、鞋柜、手上有痣。' },
          { label: '格局', content: '日奇入网：癸水滋润乙木，但也可能被网罗。修道避祸吉，余事不利，主有同伴陷害或牵连。' },
        ],
      },
    ],
  },
  {
    id: 'combo-bing',
    char: '丙',
    pinyin: 'Bǐng 组合',
    summary: '丙火组合：月奇之威',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '丙+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '炉灶、窗子、台灯等。' },
          { label: '外景', content: '开红花的植物、热力管线、热能器、电灯杆等。' },
          { label: '联想', content: '牵牛花、花开了、红花、妻子有外遇、妻子是警察。' },
          { label: '格局', content: '日月并行：丙火生乙木(误，实为木生火)，艳阳照花草。公私皆利，百事可为，吉。' },
        ],
      },
      {
        title: '丙+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '厨房、明亮的窗户等。' },
          { label: '外景', content: '电器设备、炉冶，或地势高。' },
          { label: '联想', content: '窗户明亮、向日葵园地、火警、消防队、化工厂、熊熊烈火、加油站。' },
          { label: '格局', content: '月奇悖师：二阳相遇，火势太旺，易生乱。文书逼迫，破耗遗失，主单据票证不明。' },
        ],
      },
      {
        title: '丙+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '灶、灯等明亮发光或发热的物体。' },
          { label: '外景', content: '电器设备、炉冶，或地势高等。' },
          { label: '联想', content: '偷情；煤气灶；肠炎、牙周炎。' },
          { label: '格局', content: '月奇朱雀：三奇之二，火光互映。贵人文书吉，常人平静，利于文书、信息之事。' },
        ],
      },
      {
        title: '丙+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '灯、炉、电器等。' },
          { label: '外景', content: '窑灶、地势高而开阔，或是红墙，墙边有电器设备等。' },
          { label: '联想', content: '墙上有红壁灯、红墙、红房子、变压器、路上有交警、窑厂。' },
          { label: '格局', content: '飞鸟跌穴：火生土，吉格。百事吉，不费力而得财，利于投资、求财、远行。' },
        ],
      },
      {
        title: '丙+己',
        logic: '',
        subItems: [
          { label: '内景', content: '圆形垃圾桶、堆放杂物等。' },
          { label: '外景', content: '圆形的坑、红色绳状物、红砖堆等。' },
          { label: '联想', content: '肠炎、垃圾桶、红砖、圆形的坑、红土地、热气包。' },
          { label: '格局', content: '火悖入刑：丙火生己土，但己土晦火。囚人刑杖，文书不行，吉门得吉，凶门转凶。' },
        ],
      },
      {
        title: '丙+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '明亮的窗或门、金属发热体等。' },
          { label: '外景', content: '灯塔、电线杆等。' },
          { label: '联想', content: '国道、公车、执法部门的车、灯塔、电杆、枪战、警匪片、警察抓贼、电线杆。' },
          { label: '格局', content: '荧入白：火克金，激烈的冲突。门户破败，盗贼耗失，防失火，防盗贼。' },
        ],
      },
      {
        title: '丙+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '红色的花，或花生米、红豆等物品。' },
          { label: '外景', content: '高出地面的小路、圆形金属物体。' },
          { label: '联想', content: '红花、红果、花生米、罚款、红豆、第三者出问题。' },
          { label: '格局', content: '月奇相合：丙辛合水，合中有变。谋事成就，病人不凶，利于合作、谈判。' },
        ],
      },
      {
        title: '丙+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '热水器、暖水瓶、圆形容水器等。' },
          { label: '外景', content: '红色漂浮物、圆形的水池等。' },
          { label: '联想', content: '圆形的水池、血流成河、红河、热水、红鱼、巡警、巡逻艇、水塔。' },
          { label: '格局', content: '火入天罗：水火相激，冲突对立。为客不利，是非颇多，防止口舌争斗。' },
        ],
      },
      {
        title: '丙+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '红酒、红醋、红色饮料、热水管线等。' },
          { label: '外景', content: '热力管线、荷花塘、热水井等。' },
          { label: '联想', content: '红酒、葡萄酒、荷花塘、淫荡、天罗地网、喜酒。' },
          { label: '格局', content: '华盖悖师：水火相克，阴阳冲突。阴人害事，灾祸频生，防小人暗算。' },
        ],
      },
    ],
  },
  {
    id: 'combo-ding',
    char: '丁',
    pinyin: 'Dīng 组合',
    summary: '丁火组合：星奇之智',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '丁+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '首饰品、电子产品、红色艺术品等。' },
          { label: '外景', content: '开小红花或带刺的植物、小树。' },
          { label: '联想', content: '拐弯的丁字路，艺术灯。' },
          { label: '格局', content: '人遁吉格：木生火，文书顺利。贵人加官进爵，常人财喜，婚姻和美。' },
        ],
      },
      {
        title: '丁+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '电器设备、圆形灯具等。' },
          { label: '外景', content: '地势高，有电厂、锅炉厂等。' },
          { label: '联想', content: '文章乱了，票据出麻烦了，情人还有他人。' },
          { label: '格局', content: '星随月转：阴火遇阳火，光芒被夺。贵人越级高升，常人乐极生悲，主下属侵权。' },
        ],
      },
      {
        title: '丁+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '灯或电器、电子物品等。' },
          { label: '外景', content: '地势高，有房檐屋角类物、尖状建筑物等。' },
          { label: '联想', content: '节日灯，组合灯，转盘道，经常做第三者女人。' },
          { label: '格局', content: '星奇入太阴：双丁相遇，伏吟。文书即至，百事皆吉，利于文书证件之事。' },
        ],
      },
      {
        title: '丁+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '墙上有灯、或图画等物，墙有红色物等。' },
          { label: '外景', content: '墙角状物体，墙面反光，路灯、电线杆。' },
          { label: '联想', content: '桌子上有台灯、方形灯箱、裸女，牙龈肿胀。' },
          { label: '格局', content: '青龙转光：火生土，吉格。官人升迁，常人威昌，利于求官、求名。' },
        ],
      },
      {
        title: '丁+己',
        logic: '',
        subItems: [
          { label: '内景', content: '有凌乱物品的灯等。' },
          { label: '外景', content: '塑料、玻璃、瓷片等垃圾，凌乱的砖头、瓦片。' },
          { label: '联想', content: '证件过期了，灯泡坏了，做美容的（己为皮肤），阑尾手术、伤口、不检点的女人。' },
          { label: '格局', content: '火入勾陈：丁火生己土，私欲心机。奸私仇怨，事多暗昧，防女人是非。' },
        ],
      },
      {
        title: '丁+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '炉灶、电器等。' },
          { label: '外景', content: '路口、铁塔、高楼等。' },
          { label: '联想', content: '十字路口、女人遇到了小偷、房间被隔开了。' },
          { label: '格局', content: '文书阻隔：火克金，但庚金强大，阻力重重。行人必归，音信难通，主文书受阻。' },
        ],
      },
      {
        title: '丁+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '小型电器、金银首饰用品、手电筒、小型灯具等。' },
          { label: '外景', content: '岔路，或道路不平。' },
          { label: '联想', content: '女人引发问题、女人犯错、爱花钱；手术有问题；眼疾。' },
          { label: '格局', content: '朱雀入狱：火克金，辛金受损，错误发生。罪人释裘，官人失位，防口舌官司。' },
        ],
      },
      {
        title: '丁+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '电动设备、电热设备等。' },
          { label: '外景', content: '河口，或有温泉，或有红色飘动物等。' },
          { label: '联想', content: '暖水瓶、洗浴室、水塔，门上有灯、情人要走。' },
          { label: '格局', content: '五合化木：丁壬淫荡之合，也主合伙。贵人恩诏，讼狱公平，利于合作、婚姻。' },
        ],
      },
      {
        title: '丁+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '洗手间、电热设备、电动设备等。' },
          { label: '外景', content: '废水、污水、脏水。' },
          { label: '联想', content: '暖水瓶、洗浴室、水塔；上厕所；近视眼。' },
          { label: '格局', content: '朱雀投江：水克火，文书口舌是非。音信沉溺，文书口舌，防小人、防是非。' },
        ],
      },
    ],
  },
  {
    id: 'combo-wu',
    char: '戊',
    pinyin: 'Wù 组合',
    summary: '戊土组合：甲子之本',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '戊+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '陶制艺术品等。' },
          { label: '外景', content: '弯曲的墙、牛圈、猪圈等。' },
          { label: '联想', content: '墙头起伏不平；墙头草；有钱多次花。' },
          { label: '格局', content: '青龙合灵：木克土，但甲乙木也为官星。门吉事吉，门凶事凶，利于合作、集资。' },
        ],
      },
      {
        title: '戊+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '保温瓶、微波炉、包糖罐等物。' },
          { label: '外景', content: '窑灶炉冶、热力塔等。' },
          { label: '联想', content: '得到钱了；交罚款；变压器；鼻炎。' },
          { label: '格局', content: '青龙返首：火生土，极吉之格。大吉大利，谋为遂意，利于投资、求财。' },
        ],
      },
      {
        title: '戊+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '桃子、馅饼、包子等物。' },
          { label: '外景', content: '砖墙，或有墙角。' },
          { label: '联想', content: '壁灯、鼻炎、花钱找情人、胃开刀、乳腺手术。' },
          { label: '格局', content: '青龙耀明：火生土，吉利。谒贵求名吉，若值墓迫，招惹是非。' },
        ],
      },
      {
        title: '戊+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '墙边有垃圾、杂乱物，墙边有食品等。' },
          { label: '外景', content: '坟地、土丘、冈岭等。' },
          { label: '联想', content: '双倍的投资；梯子；傻子；双份收入；背靠背。' },
          { label: '格局', content: '伏吟：土土重叠，阻隔加倍。凡事闭塞阻滞，静守为吉，不宜妄动。' },
        ],
      },
      {
        title: '戊+己',
        logic: '',
        subItems: [
          { label: '内景', content: '墙边有垃圾、杂乱物，墙边有食品等。' },
          { label: '外景', content: '坟地、陵园、垃圾堆等。' },
          { label: '联想', content: '老板的想法、墙边有垃圾。' },
          { label: '格局', content: '贵人入狱：阳土遇阴土，陷入陷阱。公私不利，凡事难行，防破财、受骗。' },
        ],
      },
      {
        title: '戊+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '水泥柱、水泥横梁等。' },
          { label: '外景', content: '桥梁、水泥路等。' },
          { label: '联想', content: '拉砖的车；钱丢了；交罚款了。' },
          { label: '格局', content: '值符飞宫：甲木由于庚金克制而飞走。吉事不吉，凶事更凶，防破财、灾祸。' },
        ],
      },
      {
        title: '戊+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '墙面不平，有颗粒或裂缝等，或有苹果、梨子等物。' },
          { label: '外景', content: '断裂的墙、墙上有裂缝、沙堆、砖堆、石头堆等。' },
          { label: '联想', content: '电线杆、鼻子有病；要破财了；墙上有裂缝、有沙堆、墙不平、墙角冲射、肉里有碎骨头。' },
          { label: '格局', content: '青龙折足：甲木遇辛金，受损。吉门有生助，尚能谋事，若逢凶门，主招灾、破财、足疾。' },
        ],
      },
      {
        title: '戊+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '椰子、西瓜、坛子、水缸等水具。' },
          { label: '外景', content: '蓄水池、堤坝、河堤等。' },
          { label: '联想', content: '花钱如流水；水库；水缸、桥梁。' },
          { label: '格局', content: '青龙入天牢：土克水，但水大土流。凡事不利，损财招灾，防牢狱之灾。' },
        ],
      },
      {
        title: '戊+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '洗手间、厨房等。' },
          { label: '外景', content: '湿土、湿泥、水泥管线等。' },
          { label: '联想', content: '桥梁、金屋藏娇、房子里有卫生间、足疗。' },
          { label: '格局', content: '青龙华盖：戊癸相合，吉。招福临门，汇合有情，利于婚姻、合作。' },
        ],
      },
    ],
  },
  {
    id: 'combo-ji',
    char: '己',
    pinyin: 'Jǐ 组合',
    summary: '己土组合：地户之隐',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '己+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '绳索、电线乱成一团。' },
          { label: '外景', content: '田园、菜园、公园等。' },
          { label: '联想', content: '犹疑不决、作家、画家、搞艺术的、搞策划的、拉肚子。' },
          { label: '格局', content: '墓神不明：木克土，己土受克。地户逢星，宜遁迹隐形，不宜张扬。' },
        ],
      },
      {
        title: '己+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '厨房或阳台。' },
          { label: '外景', content: '花园、锅炉房、饭店、食品加工厂等。' },
          { label: '联想', content: '设想的计划乱套了；肚里窝火；思想混乱；肠炎；糊涂。' },
          { label: '格局', content: '火悖地户：火生土，但己土晦火。男人冤冤相害，女人必致淫污，主乱子。' },
        ],
      },
      {
        title: '己+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '电器设备、电磁壶、茶壶、尖锐的垃圾等物品。' },
          { label: '外景', content: '花园、变压器、菜园、公园等。' },
          { label: '联想', content: '垃圾邮件；变压器；土地官司。' },
          { label: '格局', content: '朱雀入墓：火生土，但丁火入墓。文书词讼，先曲后直，主事情起初有波折。' },
        ],
      },
      {
        title: '己+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '墙边有垃圾、杂乱物，墙边有食品等。' },
          { label: '外景', content: '坟地、陵园、垃圾堆等。' },
          { label: '联想', content: '肚子大了、怀孕了、大肚和尚；临值符弥勒佛；想钱了；脂肪瘤。' },
          { label: '格局', content: '犬遇青龙：土土相助。门吉得谋，门凶失货，利于合作、集资。' },
        ],
      },
      {
        title: '己+己',
        logic: '',
        subItems: [
          { label: '内景', content: '垃圾、塑料瓶等。' },
          { label: '外景', content: '坟地、垃圾厂等。' },
          { label: '联想', content: '坟头很多；再三考虑；自私吝啬。' },
          { label: '格局', content: '地户逢鬼：伏吟，病星重叠。病者必死，百事不遂，主事情拖拉、变动。' },
        ],
      },
      {
        title: '己+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '锅、铲等食品加工用具，或马桶、垃圾桶等。' },
          { label: '外景', content: '弯曲的大路，路边有垃圾堆等。' },
          { label: '联想', content: '想阻止而没有阻止；装垃圾的车；有不健康的想法。' },
          { label: '格局', content: '刑格返名：土生金，但乙庚合，己为中介。词讼先动者不利，谋为不遂，防受人连累。' },
        ],
      },
      {
        title: '己+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '颗粒食品，金属项链和手镯，金属摆件等。' },
          { label: '外景', content: '羊肠小路，路旁有土堆或垃圾堆、菜园、坟地等。' },
          { label: '联想', content: '想法错了；拉肚子、肠炎；皮肤病；羊肠小道；想犯错误。' },
          { label: '格局', content: '游魂入墓：土生金，辛金入墓。阴人鬼祟，惊怪之事，防小人作祟。' },
        ],
      },
      {
        title: '己+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '有动的物品。' },
          { label: '外景', content: '一条弯曲的河流、或不规则的湖泊。' },
          { label: '联想', content: '洗澡、上厕所、不想干了、要走了、思想开小差。' },
          { label: '格局', content: '地网高张：土克水，浑浊不清。奸情杀伤，凡事不吉，主事情纠缠不清。' },
        ],
      },
      {
        title: '己+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '泥或陶瓷的酒瓶、油瓶、饮料瓶。' },
          { label: '外景', content: '坑厕、垃圾塘、泥塘等。' },
          { label: '联想', content: '想去厕所；想喝酒；拉肚子。' },
          { label: '格局', content: '地刑玄武：土克水，私欲泛滥。疾病垂危，词讼有囚狱之灾，大凶。' },
        ],
      },
    ],
  },
  {
    id: 'combo-geng',
    char: '庚',
    pinyin: 'Gēng 组合',
    summary: '庚金组合：太白之刚',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '庚+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '横梁弯曲，窗旁有爬山虎或牵牛花，窗旁放艺术品等。' },
          { label: '外景', content: '弯曲的路、钢结构的门窗。' },
          { label: '联想', content: '走弯路；曲折的历程；夫妻在一起；金属的艺术品；高明的医生；过硬的绘画艺术。' },
          { label: '格局', content: '太白逢星：乙庚合，牵绊。退吉进凶，谋为不利，主事情有阻碍。' },
        ],
      },
      {
        title: '庚+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '明亮的窗子或门。' },
          { label: '外景', content: '锅炉、化工设备等。' },
          { label: '联想', content: '锅炉工；开车遇到了红灯；贼来了；车祸；矿难。' },
          { label: '格局', content: '太白入荧：火克金，贼必来。为客进利，为主破财，利于进攻。' },
        ],
      },
      {
        title: '庚+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '窗子上有灯或电子设备等。' },
          { label: '外景', content: '大型的金属电力设备、耀眼的刚性建筑。' },
          { label: '联想', content: '监视器；丈夫有情人；丁字路口；有危险了；停电了；电磁炉坏了。' },
          { label: '格局', content: '亭亭之格：火克金，私情之乱。因私狎昵，官司是非，主男女关系混乱。' },
        ],
      },
      {
        title: '庚+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '有横梁。' },
          { label: '外景', content: '铁塔、墙角、铁栅栏、水泥墙等。' },
          { label: '联想', content: '路上有土堆；路断了；面目全非；胃癌。' },
          { label: '格局', content: '天乙伏宫：甲申庚，甲子戊，相冲。百事不可谋，大凶，防破财、灾祸。' },
        ],
      },
      {
        title: '庚+己',
        logic: '',
        subItems: [
          { label: '内景', content: '横梁、门窗旁堆满垃圾等。' },
          { label: '外景', content: '废铁堆、废水泥堆、道路不平等。' },
          { label: '联想', content: '水泥路面、路上有垃圾、路上遇到一条狗；床下很乱、环卫车。' },
          { label: '格局', content: '官符刑格：土生金，但己土卑湿。官司被刑，难逃其咎，主有牢狱之灾。' },
        ],
      },
      {
        title: '庚+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗、钢性门窗、两个门窗等。' },
          { label: '外景', content: '有关卡、收费站的道路，或有两条路等。' },
          { label: '联想', content: '两车相撞、车祸、警匪片、两个丈夫、上下铺、骨头断了。' },
          { label: '格局', content: '太白同宫：战格，冲突。兄弟雷攻，官灾横祸，主两强相争，必有一伤。' },
        ],
      },
      {
        title: '庚+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '大小门窗两个。' },
          { label: '外景', content: '大路路面不平或坏损，大小两条道路，路边有碎石等。' },
          { label: '联想', content: '骨裂；拉肚子；车出问题了；床坏了；关节炎。' },
          { label: '格局', content: '白虎干格：金金互击。远行车折马死，求财大凶，防车祸、伤灾。' },
        ],
      },
      {
        title: '庚+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '窗子有窗帘等，有水管等。' },
          { label: '外景', content: '车站、港口、马路等。' },
          { label: '联想', content: '翻车了、车掉水沟里了、贼跑了、仇人溜了。' },
          { label: '格局', content: '小格：金生水，水流而动。远行迷失，音信难通，主行人不归。' },
        ],
      },
      {
        title: '庚+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '金属管道、垃圾道。' },
          { label: '外景', content: '储运罐、水管、车站等。' },
          { label: '联想', content: '车陷到坑里了；酒鬼；上厕所了。' },
          { label: '格局', content: '大格：金生水，动荡。行人至，官司止，生产母子俱伤，主车祸、伤灾。' },
        ],
      },
    ],
  },
  {
    id: 'combo-xin',
    char: '辛',
    pinyin: 'Xīn 组合',
    summary: '辛金组合：错误之变',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '辛+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '手镯、项链等金属制品和艺术品。' },
          { label: '外景', content: '铁丝网、金属线、结果或开花的小树或植物。' },
          { label: '联想', content: '歪点子；挑老婆的毛病；为女人犯罪。' },
          { label: '格局', content: '白虎猖狂：金克木，乙木受损。家败人亡，远行有灾，主凶。' },
        ],
      },
      {
        title: '辛+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '厨房、电热器等。' },
          { label: '外景', content: '饭店、厨房、铁厂、电厂、机械厂、首饰加工厂等。' },
          { label: '联想', content: '被警察抓了；闯红灯。' },
          { label: '格局', content: '干合悖师：丙辛合，因财致祸。荧惑出现，占雨无雨，占晴旱，主合作生变。' },
        ],
      },
      {
        title: '辛+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '首饰，电话、电器等。' },
          { label: '外景', content: '路口。' },
          { label: '联想', content: '近视眼、肺部手术、食管开刀。' },
          { label: '格局', content: '狱神得奇：火克金，经商获利。经商获倍利，囚人逢赦，吉。' },
        ],
      },
      {
        title: '辛+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '墙上有钉子等。' },
          { label: '外景', content: '墙上镶有瓷砖，墙不平或有损伤等。' },
          { label: '联想', content: '靠足疗挣钱；经济问题；墙坏了；罚款；二手房。' },
          { label: '格局', content: '困龙被伤：甲子戊遇辛金。官司破财，吉事不吉，防破财。' },
        ],
      },
      {
        title: '辛+己',
        logic: '',
        subItems: [
          { label: '内景', content: '窗子和阳台，或窗子旁堆有垃圾等。' },
          { label: '外景', content: '小路，路旁有垃圾或菜园、土坑等。' },
          { label: '联想', content: '青春痘、皮肤病、粉刺、皮肤粗糙、错误的想法、坟地、口误。' },
          { label: '格局', content: '入狱自刑：土生金，但为私欲。奴仆背主，讼诉难伸，主小人作祟。' },
        ],
      },
      {
        title: '辛+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗，门窗上有锁等。' },
          { label: '外景', content: '两条道路，小路上有障碍物。' },
          { label: '联想', content: '路上遇阻；车祸、锁坏了；小路连接大路；路上有障碍物。' },
          { label: '格局', content: '白虎出力：金金相撞。刀刃相接，主客相伤，主争斗、血光。' },
        ],
      },
      {
        title: '辛+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗，或门窗有毛病。' },
          { label: '外景', content: '一条崎岖的小路。' },
          { label: '联想', content: '二进宫、自责、同样的问题一再发生。' },
          { label: '格局', content: '伏吟天庭：伏吟，自刑。公废私就，讼狱自罹，主错误重复发生。' },
        ],
      },
      {
        title: '辛+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '钟表、手表等，玩具模型等。' },
          { label: '外景', content: '车站、码头等。' },
          { label: '联想', content: '一座小桥、花钱如流水、流动资金、因贪污而入狱、风流成性。' },
          { label: '格局', content: '凶蛇入狱：金生水，两男争女。两男争女，讼狱不息，主男女是非。' },
        ],
      },
      {
        title: '辛+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '水壶、酒瓶、饮料瓶、水瓶、溶水器等。' },
          { label: '外景', content: '路旁有泥坑或池塘或低洼地等。' },
          { label: '联想', content: '腿脚出问题、沼泽地。' },
          { label: '格局', content: '天牢华盖：金生水，误入歧途。日月失明，误入天网，主牢狱之灾。' },
        ],
      },
    ],
  },
  {
    id: 'combo-ren',
    char: '壬',
    pinyin: 'Rén 组合',
    summary: '壬水组合：天牢之流',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '壬+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '漂亮的窗帘，艺术的大门等。' },
          { label: '外景', content: '一条弯曲的河流，或人流很多的街道。' },
          { label: '联想', content: '拐弯的河流、道路曲折、门变形了、人流很多的街道、长发飘逸。' },
          { label: '格局', content: '小蛇得势：水生木，顺风顺水。女子柔顺，男子通达，测孕生子，大吉。' },
        ],
      },
      {
        title: '壬+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '红窗帘，透光的门窗，热水器等。' },
          { label: '外景', content: '圆形的湖泊或水池。' },
          { label: '联想', content: '太阳能热水器、温泉、温水、水晶球。' },
          { label: '格局', content: '水蛇入火：水火相冲。官灾刑禁，络绎不绝，主是非不断。' },
        ],
      },
      {
        title: '壬+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '连体的门窗，有热水器，交会的水管等。' },
          { label: '外景', content: '河流交汇或有道路交汇。' },
          { label: '联想', content: '有私心了、歪主意、非分之想、有猫腻、在外面有情人、走错道了、要做手术了、流产了。' },
          { label: '格局', content: '干合星奇：丁壬合，有情之合。官职荣升，狱讼公平，利于合作、婚姻。' },
        ],
      },
      {
        title: '壬+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '水管堵塞、洗澡池。' },
          { label: '外景', content: '河堤、水坝、桥梁或道路堵塞等。' },
          { label: '联想', content: '流动商贩、商人、在流动中赚钱、要搬家了、水上建筑。' },
          { label: '格局', content: '小蛇化龙：土克水，受阻。男人发达，女人产婴，吉。' },
        ],
      },
      {
        title: '壬+己',
        logic: '',
        subItems: [
          { label: '内景', content: '弯曲水管，或有水池。' },
          { label: '外景', content: '河水流通不畅，街道人流拥挤。' },
          { label: '联想', content: '拥挤的人流、车道、火车的硬座、流水不畅、水路弯弯。' },
          { label: '格局', content: '反吟蛇刑：土克水，浑浊。大祸将至，顺守可吉，主官司败诉。' },
        ],
      },
      {
        title: '壬+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗经常不开或上锁等。' },
          { label: '外景', content: '河流上有闸口，或河道堵塞，河上有桥梁，或立交桥等。' },
          { label: '联想', content: '客车、出租车、抗洪、换丈夫、公平。' },
          { label: '格局', content: '太白擒蛇：金生水，动荡。刑狱公平，剖决邪正，利于判决。' },
        ],
      },
      {
        title: '壬+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗管不严、或门窗出问题等。' },
          { label: '外景', content: '河流改道、出岔，道路分成两岔等。' },
          { label: '联想', content: '走错路了、路岔口、项链丢了、河改道了。' },
          { label: '格局', content: '螣蛇相缠：金生水，被骗。吉门得吉，凶门得凶，主被人欺骗。' },
        ],
      },
      {
        title: '壬+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗开阔、浴室厨房大等。' },
          { label: '外景', content: '宽广的河流、湖泊，或宽广的街道，或宽广的广场等。' },
          { label: '联想', content: '洪水、浴室、大雨磅礴、海浪滔滔。' },
          { label: '格局', content: '蛇入地罗：水势浩大。外人缠绕，内事索索，主事情复杂难解。' },
        ],
      },
      {
        title: '壬+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '窗户很脏，不卫生，洗手间、厨房脏乱等。' },
          { label: '外景', content: '河流混浊、肮脏。街道凌乱不平。' },
          { label: '联想', content: '游客、饮料厂、洗澡堂。' },
          { label: '格局', content: '幼女奸淫：阴阳水混杂。家有丑声，门庭败落，大凶。' },
        ],
      },
    ],
  },
  {
    id: 'combo-gui',
    char: '癸',
    pinyin: 'Guǐ 组合',
    summary: '癸水组合：天网之困',
    tags: [],
    story: '',
    coreOrigins: [
      {
        title: '癸+乙',
        logic: '',
        subItems: [
          { label: '内景', content: '水管线，煤气管线，有淋浴器、水龙头，醋瓶、饮料、调料等。' },
          { label: '外景', content: '水塘、水草、低洼地等。' },
          { label: '联想', content: '洗头房、洗头、下水道拐弯了。' },
          { label: '格局', content: '华盖逢星：水生木，贵人助。贵人禄位，常人平安，吉。' },
        ],
      },
      {
        title: '癸+丙',
        logic: '',
        subItems: [
          { label: '内景', content: '灭火器、热水器、暖气等。' },
          { label: '外景', content: '圆形水池、池塘等，有热水管线，地下热能或消防系统等。' },
          { label: '联想', content: '红眼病、热水器、脚发炎。' },
          { label: '格局', content: '华盖悖师：水克火，贵人惹祸。贵贱不利，唯上人见喜，防小人。' },
        ],
      },
      {
        title: '癸+丁',
        logic: '',
        subItems: [
          { label: '内景', content: '下水井、阴沟、厕所等。' },
          { label: '外景', content: '星罗棋布的池塘，或水道纵横，或污水遍布。' },
          { label: '联想', content: '近视眼。' },
          { label: '格局', content: '螣蛇夭矫：水克火，文书官司。文书官司，火焚也，主官司口舌。' },
        ],
      },
      {
        title: '癸+戊',
        logic: '',
        subItems: [
          { label: '内景', content: '汤盆、酒坛、酒瓶、水缸等物器。' },
          { label: '外景', content: '墙边有污水池、污水井等。' },
          { label: '联想', content: '子宫增生、做足疗的。' },
          { label: '格局', content: '天乙会合：合局，吉。吉门宜求财，婚姻喜美，利于合作。' },
        ],
      },
      {
        title: '癸+己',
        logic: '',
        subItems: [
          { label: '内景', content: '发酵物品、发霉的物品、厕所、畜物间等。' },
          { label: '外景', content: '垃圾脏水，湿泥坑等。' },
          { label: '联想', content: '垃圾、发酵了、酒箱子、醋坛子。' },
          { label: '格局', content: '华盖入地：土克水，入墓。音信皆阻，躲灾避难，宜静守。' },
        ],
      },
      {
        title: '癸+庚',
        logic: '',
        subItems: [
          { label: '内景', content: '门窗肮脏，门窗边有污物等。' },
          { label: '外景', content: '道路有积水、脏物、道路坑洼不平。' },
          { label: '联想', content: '要打架了。窗台上有水珠。' },
          { label: '格局', content: '太白入网：金生水，争斗。以暴力争讼，自罹罪责，主官司刑狱。' },
        ],
      },
      {
        title: '癸+辛',
        logic: '',
        subItems: [
          { label: '内景', content: '发酵、变质的液体或饮料、调料瓶。' },
          { label: '外景', content: '酿造厂、饮料厂、小路上有积水、脏物，道路坑洼不平、砖石砌成的水池。' },
          { label: '联想', content: '肾结石、吸毒。' },
          { label: '格局', content: '网盖天牢：金生水，牢狱。官司败诉，死罪难逃，大凶。' },
        ],
      },
      {
        title: '癸+壬',
        logic: '',
        subItems: [
          { label: '内景', content: '黑暗潮湿，双层窗帘，有厨房洗手间、线管等。' },
          { label: '外景', content: '大小交错的河或湖池，或热闹的街巷。' },
          { label: '联想', content: '流窜犯、跑业务的、小雨转大雨。' },
          { label: '格局', content: '复见天网：水势泛滥。嫁娶重婚，后嫁无子，不吉。' },
        ],
      },
      {
        title: '癸+癸',
        logic: '',
        subItems: [
          { label: '内景', content: '黑暗潮湿、霉气味，有洗手间、厨房等。' },
          { label: '外景', content: '河流纵横，或街道车水马龙，或是湿地洼地等。' },
          { label: '联想', content: '大眼睛、阴雨连绵。' },
          { label: '格局', content: '天网四张：伏吟，大凶。行人失伴，病讼皆伤，万事皆休。' },
        ],
      },
    ],
  },
];

const COMBO_LABEL_ONLY = /^(联想|外景|内景|其他)\s*[：:]\s*$/;
const COMBO_LINE_PREFIX = /^(联想|外景|内景|其他)\s*[：:]\s*/;
const DISEASE_HINT_RE = /(疾病|炎|癌|瘤|疼|痛|痒|感染|结石|手术|溃疡|增生|病变|湿疹|肿胀|坏死|萎缩|流脓|流血|麻木|骨折|骨裂|畸形)/;

const normalizeSupplementText = (raw: string): string => String(raw || '')
  .replace(/^[+\-*\s]+/, '')
  .replace(/[ \t]+/g, ' ')
  .trim();

const normalizeDedupeContent = (raw: string): string => normalizeSupplementText(raw)
  .replace(/[。；;]+$/g, '')
  .trim();

const inferSupplementLabel = (line: string): string => {
  const t = normalizeSupplementText(line);
  const m = t.match(/^(联想|外景|内景|其他)\s*[：:]/);
  if (m) return m[1];
  if (DISEASE_HINT_RE.test(t)) return '疾病补充';
  return '补充';
};

const stripSupplementPrefix = (line: string): string => {
  const t = normalizeSupplementText(line);
  if (COMBO_LABEL_ONLY.test(t)) return '';
  return t.replace(COMBO_LINE_PREFIX, '').trim();
};

const mergeComboSupplements = (base: SymbolData[]): SymbolData[] => {
  return base.map((group) => ({
    ...group,
    coreOrigins: (group.coreOrigins || []).map((origin) => {
      const comboKey = String(origin?.title || '').trim();
      const supplementLines = PAN_STEM_COMBO_LOOKUP[comboKey];
      if (!Array.isArray(supplementLines) || !supplementLines.length) return origin;

      const subItems = Array.isArray(origin?.subItems) ? [...origin.subItems] : [];
      const seen = new Set(
        subItems.map((item) => normalizeDedupeContent(String(item.content || ''))).filter(Boolean),
      );

      for (const raw of supplementLines) {
        const content = stripSupplementPrefix(raw);
        if (!content) continue;
        const normalizedContent = normalizeDedupeContent(content);
        if (!normalizedContent) continue;
        if (seen.has(normalizedContent)) continue;
        const label = inferSupplementLabel(raw);
        seen.add(normalizedContent);
        subItems.push({ label, content });
      }

      return {
        ...origin,
        subItems,
      };
    }),
  }));
};

export const stemCombinationsData: SymbolData[] = mergeComboSupplements(baseStemCombinationsData);
